<template>
  <a-modal
    :width="modalWidth"
    :style="modalStyle"
    :visible="visible"
    :maskClosable="false"
    @cancel="handleCancel">
    <template slot="footer">
      <a-button @click="handleCancel">{{language['common.closeButton']}}</a-button>
    </template>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="false">
      <span slot="action" slot-scope="text, record">
        <a @click="handleBack(record.id)" v-has="'dict:takeBack'" ><a-icon type="redo"/>{{language['sys.dictfunc.dictTakeBack']}}</a>
        <a-divider type="vertical"/>
        <a @click="handleDelete(record.id)" v-has="'dict:realDelete'" ><a-icon type="scissor"/>{{language['sys.dictfunc.realDelete']}}</a>
      </span>
    </a-table>

  </a-modal>


</template>

<script>
  import { getAction,deleteAction,putAction } from '@/api/manage'
  export default {
    name: "DictDeleteList",
    data () {
      return {
        modalWidth: '90%',
        modalStyle: { 'top': '20px'},
        title: '操作',
        visible: false,
        loading: false,
        dataSource:[],
        //columns:[]
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 120,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: this.language['sys.dictfunc.dictName'],
              align: "left",
              dataIndex: 'dictName'
            },
            {
              title: this.language['sys.dictfunc.dictCode'],
              align: "left",
              dataIndex: 'dictCode'
            },
            {
              title: this.language['common.desc'],
              align: "left",
              dataIndex: 'description'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align: "center",
              scopedSlots: {customRender: 'action'}
            }
          ]
        }
      },
    },
    methods: {
      handleCancel(){
        this.visible = false
        //回收站字典列表刷新
        this.$emit("refresh")
      },
      show(){
        this.visible = true
        this.loadData();
      },
      loadData(){
        this.loading = true
        getAction("/sys/dict/deleteList").then(res=>{
          this.loading = false
          if(res.success){
            this.dataSource = res.result
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleBack(id){
        putAction("/sys/dict/back/"+id).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadData();
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleDelete(id){
        this.$confirm({
          title: this.language['sys.dictfunc.realDeleteDict'],
          content: (<div>
            <p>{this.language['sys.dictfunc.realDeleteTip1']}</p>
            <p style="color:red;">{this.language['sys.dictfunc.realDeleteTip2']}</p>
          </div>),
          centered: false,
          onOk: () => {
          var that = this;
          deleteAction("/sys/dict/deletePhysic/"+id).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.loadData();
            } else {
              that.$message.warning(res.message);
            }
          });
        },
      })
      },


    }
  }
</script>

<style scoped>

</style>